import image1 from '../../assets/programs/sci_tech_spins/image1.webp'

const sci_tech_data = {
    "title": "Sci-Tech Spins for Schools",
    "description": "The SciTech Spins lecture series is an outreach initiative for school students, especially from classes 9th–12th. It aims to bridge the gap between academia and society, and promote curiosity and innovation. This initiative is one of many efforts by IIT Delhi to encourage school students, especially girls, to pursue higher education in STEM. For more details: https://youtube.com/playlist?list=PL0x7Tsixz0fmYaQrYRCF70Kv0wU6L64Wi&feature=shared",
    "content": [
        {
            "primaryHeading": "",
            "subContent": [
                {
                    "secondaryHeading": "",
                    "description": "",
                    "images": [
                        {
                            "src": image1,
                            "desc": ""
                        }
                    ]
                }
            ]
        }
    ]
}

export default sci_tech_data;